import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap, useMapEvents } from "react-leaflet";
import L from "leaflet";
import iconRetina from "leaflet/dist/images/marker-icon-2x.png";
import iconUrl from "leaflet/dist/images/marker-icon.png";
import shadowUrl from "leaflet/dist/images/marker-shadow.png";

// Fix Leaflet's default marker icon paths when bundled with webpack
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({ iconRetinaUrl: iconRetina, iconUrl, shadowUrl });

export const RISK_COLORS = { green: "#10B981", yellow: "#EAB308", red: "#EF4444" };
export const STATUS_GRAY = "#9CA3AF";
export const STATUS_BLUE = "#3B82F6";
export const STATUS_PURPLE = "#8B5CF6";

export function markerColor(r) {
  if (r.status === "resolved") return STATUS_GRAY;
  if (r.status === "in_progress") return STATUS_BLUE;
  if (r.category === "reusable") return STATUS_PURPLE;
  return RISK_COLORS[r.risk_level] || STATUS_GRAY;
}

export function pinIcon(color, msgCount = 0) {
  const badge = msgCount > 0
    ? `<div style="position:absolute;top:-6px;right:-8px;min-width:20px;height:20px;padding:0 5px;background:#111827;color:#fff;font-size:10px;font-weight:700;font-family:'DM Sans',sans-serif;border-radius:9999px;border:2px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,.25);display:flex;align-items:center;justify-content:center;line-height:1;">💬 ${msgCount}</div>`
    : "";
  const svg = `<div style="position:relative;width:30px;height:30px;">
    <div style="width:30px;height:30px;border-radius:50% 50% 50% 0;background:${color};transform:rotate(-45deg);border:3px solid #fff;box-shadow:0 4px 12px rgba(0,0,0,.2);"></div>
    <div style="position:absolute;top:9px;left:9px;width:12px;height:12px;background:rgba(255,255,255,.9);border-radius:50%;"></div>
    ${badge}
  </div>`;
  return L.divIcon({ html: svg, iconSize: [30, 30], iconAnchor: [15, 30], className: "tc-pin" });
}

export const TILE_LAYERS = {
  standard: {
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attr: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    maxZoom: 19,
  },
  satellite: {
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
    attr: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    maxZoom: 19,
  },
};

export const TILE_URL = TILE_LAYERS.standard.url;
export const TILE_ATTR = TILE_LAYERS.standard.attr;

/** Fires cb on the first successful tile load and on tileerror (grouped). Supports mode='standard'|'satellite'. */
export function TileHealth({ onLoad, onError, mode = "standard" }) {
  const layer = TILE_LAYERS[mode] || TILE_LAYERS.standard;
  return (
    <TileLayer
      key={`tile-${mode}`}
      attribution={layer.attr}
      url={layer.url}
      maxZoom={layer.maxZoom}
      eventHandlers={{
        load: () => onLoad && onLoad(),
        tileerror: () => onError && onError(),
      }}
    />
  );
}

export function FlyTo({ center, zoom }) {
  const map = useMap();
  useEffect(() => {
    if (center) map.flyTo(center, zoom ?? map.getZoom(), { duration: 1.2 });
  }, [center, zoom, map]);
  return null;
}

export function ClickToSelect({ onSelect }) {
  useMapEvents({
    click(e) { onSelect && onSelect(e.latlng); },
  });
  return null;
}
